module.exports = __webpack_public_path__ + "static/media/elo.41700c0d.png";